export default "__VITE_ASSET__DqILtpp7__"